import {
  BaseEventStyleKey,
  LogItemStyleKey,
  RadiometerLabelSize,
  StatusChangeLabelSize,
} from '@features/components/ClinicalData/components/ClinicalLog/components/constants';
import { AppType } from '@features/contexts/AppProvider';

export enum LogTypeKeys {
  BaseEventItem,
  LogItemLayout,
  StatusChangeItem,
  RadiometerLayout,
}

export type LogTypeComponentTypes = BaseEventStyleKey | LogItemStyleKey | StatusChangeLabelSize | RadiometerLabelSize;

export type LogTypeStyles = {
  [key in LogTypeKeys]: LogTypeComponentTypes;
};

export type ClinicalLogStyleMap = {
  [key in AppType]: LogTypeStyles;
};
